import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6C722CF2-67CA-4CEC-9197-56C4F99D2866
 * name shield-cross-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-cross-outline.svg
 * tags
 * - Gaming / RPG 
 * - Religion 
 */
export const ShieldCrossOutlineIcon = createSvgIcon(<><path d="M21,11C21,16.5 17.2,21.7 12,23C6.8,21.7 3,16.5 3,11V5L12,1L21,5V11M12,21C15.8,20 19,15.5 19,11.2V6.3L12,3.2L5,6.3V11.2C5,15.5 8.3,20 12,21M16,9H13V6H11V9H8V11H11V19H13V11H16V9Z" /></>, 'ShieldCrossOutlineIcon');
export default ShieldCrossOutlineIcon